import { render, staticRenderFns } from "./accountAdd.vue?vue&type=template&id=1fc1f08c&scoped=true&"
import script from "./accountAdd.vue?vue&type=script&lang=js&"
export * from "./accountAdd.vue?vue&type=script&lang=js&"
import style0 from "./accountAdd.vue?vue&type=style&index=0&id=1fc1f08c&lang=scss&scoped=true&"
import style1 from "./accountAdd.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fc1f08c",
  null
  
)

export default component.exports